import { CartAlt as Cart } from "@styled-icons/boxicons-regular/CartAlt"
import { Joystick } from "styled-icons/boxicons-regular/Joystick"
import { Database } from "@styled-icons/octicons/Database"
import { Mobile2 as Mobile } from "styled-icons/icomoon/Mobile2"
import { Globe2 as Web } from "@styled-icons/bootstrap/Globe2"

import { ChevronRight } from "@styled-icons/evil/ChevronRight"

const Icons = {
  Web,
  Database,
  Joystick,
  Mobile,
  Cart,
  ChevronRight,
}

export default Icons
